import { render } from "./CommunicationTabs.vue?vue&type=template&id=0614fab0"
import script from "./CommunicationTabs.vue?vue&type=script&lang=js"
export * from "./CommunicationTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__